import './accessioningSampleCard.scss'
import React, {useCallback, useEffect, useRef, useState} from 'react';
import Grid from '@mui/material/Grid';
import {Skeleton} from '@mui/material';
import {Edit} from "@mui/icons-material";
import DetailsDataKeyValueComponent from "../details-data-key-value-component/detailsDataKeyValueComponent";
import DatePickerComponent from "../core/date-picker/DatePickerComponent";
import TimePickerComponent from "../core/time-picker/timePickerComponent";
import ButtonComponent from "../core/button/ButtonComponent";
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import {CommonService} from "../../services";
import DialogComponent from "../dialog/dialogComponent";
import {IAPIResponseType} from "../../models/api.model";
import StatusCardComponent from "../status-card/statusCardComponent";
import CardComponent from "../card/cardComponent";
import PdfPreviewComponent from "../pdf-preview/pdfPreviewComponent";
import {APIConfig, ImageConfig} from "../../../constants";
import LottieFileGenarationComponent from "../core/lottie-file-genaration/LottieFileGenarationComponent";
import FilePreviewerComponent from "../file-previewer/filePreviewerComponent";
import DrawerComponent from "../drawer/drawerComponent";
import HeadingComponent from "../heading/headingComponent";
import {Field, FieldProps, Form, Formik, FormikHelpers, FormikProps, FormikValues} from "formik";
import FormikSelectDropdownComponent from "../core/formik-select-dropdown/FormikSelectDropdownComponent";
import FormikInputComponent from "../core/formik-input/FormikInputComponent";
import TooltipComponent from "../tooltip/tooltipComponent";
import HelpIcon from "@mui/icons-material/Help";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import _ from "lodash";
import ErrorComponent from "../form-controls/error/errorComponent";
import ThumbnailComponent from "../thumbnailComponent/ThumbnailComponent";
import InputComponent from "../core/input/InputComponent";
import * as Yup from "yup";
import commonService from "../../services/common.service";
import InsuranceFormComponent from "../insurance-form/insuranceFormComponent";
import InsuranceDetailsComponent from "../insurance-details/insuranceDetailsComponent";
import AccordionComponent from "../accordion/accordionComponent";
import useFetch from "../../hooks/useFetch";


interface AccessioningSampleCardProps {
    sampleDetails: any
    status: "pending" | "accessioned" | "Ready For Collection" | undefined;
    getAccessioningSample?: Function;
}

const reviewFormValidationSchema = Yup.object({
    reason: Yup.string().required('Reason is required.'),
    comment: Yup.string(),
    // images: Yup.mixed().required('Images are required.'),
});

interface reviewFormSchema {
    reason: string;
    comment: string;
    images: any;
}

const formInitialValues: reviewFormSchema = {
    reason: "",
    comment: "",
    images: []
}

const reasonList = [
    {code: 'unlabeled specimen',title: 'Unlabeled Specimen'},
    {code: 'wrong specimen submitted',title: 'Wrong Specimen Submitted'},
    {code: 'hemolyzed',title: 'Hemolyzed'},
    {code: 'anti-coagulated specimen with Clots',title: 'Anti-coagulated specimen with Clots'},
    {code: 'inadequate volume',title: 'Inadequate Volume'},
    {code: 'insufficient for volume of preservative',title: 'Insufficient for volume of preservative'},
    {code: 'not at proper temperature',title: 'Not at proper temperature'},
    {code: 'too old',title: 'Too Old'},
    {code: 'lipemic',title: 'Lipemic'},
    {code: 'insufficient patient information',title: 'Insufficient patient information'},
    {code: 'dried swab',title: 'Dried Swab'},
    {code: 'no barcode', title: 'No Barcode'},
    {code: 'leakage', title: 'Leakage'},
    {code: 'other', title: 'Other'}
];


const InsuranceTypes = [
    {
        title: 'Primary Insurance',
        code: 'primaryInsurance',
    },
    {
        title: 'Secondary Insurance',
        code: 'secondaryInsurance',
    },
    {
        title: 'Tertiary Insurance',
        code: 'tertiaryInsurance',
    }
];
const AccessioningSampleCard = (props: AccessioningSampleCardProps) => {

        const {
            sampleDetails,
            status,
            getAccessioningSample
        } = props;

        const [dateOfCollection, setDateOfCollection] = useState<any>(sampleDetails?.dateOfCollection);
        const [timeOfCollection, setTimeOfCollection] = useState<any>(sampleDetails?.timeOfCollection);
        const [attachmentsModel, showAttachmentsModel] = useState<boolean>(false);
        const [patientAttachment, setPatientAttachment] = useState<any>("");
        const [orderAttachment, setOrderAttachment] = useState<any>("");
        const [orderAttachments, setOrderAttachments] = useState<any[]>([]);
        const [patientAttachments, setPatientAttachments] = useState<any[]>([]);
        const [sampleAttachmentsLoading, setSampleAttachmentLoading] = useState<boolean>(false);
        const [sampleAttachmentsLoaded, setSampleAttachmentLoaded] = useState<boolean>(false);
        const [sampleAttachmentsLoadingFailed, setSampleAttachmentsLoadingFailed] = useState<boolean>(false);
        const [initialValues, setInitialValues] = useState<reviewFormSchema>(formInitialValues);

        const [showReviewDrawer, setShowReviewDrawer] = useState<boolean>(false)
        const [rejectedAttachmentList, setRejectedAttachmentList] = useState<any>([]);
        const rejectFileRef = useRef<HTMLInputElement | null>(null);
        const formikRef = useRef<FormikProps<FormikValues>>(null);
        const [reAssignBarcodeModel, showReAssignBarcodeModel] = useState<boolean>(false);
        const [newBarcode, setNewBarcode] = useState<string>("");
        const [currentBarcodeNumber, setCurrentBarcodeNumber] = useState<any>(undefined);
        const [isAssignNewBarcodeSubmitting, setIsAssignNewBarcodeSubmitting] = useState<boolean>(false);
        const [isApproveBarcodeLoading, setIsApproveBarcodeLoading] = useState<boolean>(false);
        const [insuranceDrawerConfig, setInsuranceDrawerConfig] = useState<{ isOpen: boolean, selectedInsurance: any }>({
            isOpen: false,
            selectedInsurance: undefined
        });
        const [isInsuranceImageRequired, setIsInsuranceImageRequired] = useState<boolean>(false);

        const {
            response: patientInsuranceList = [],
            loading: isPatientInsuranceListLoading,
            fetchData: fetchPatientInsuranceList
        } = useFetch<any>();

        const handleApproveBarcodeAction = useCallback((sample: any) => {
            setIsApproveBarcodeLoading(true);
            const payload = {
                ...sample,
                status: 'accessioned'
            }

            CommonService._accessioning.approveSample(sample.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsApproveBarcodeLoading(false);
                    getAccessioningSample && getAccessioningSample();
                    CommonService._alert.showToast('Sample has been Approved', "success");
                })
                .catch((error: any) => {
                    CommonService.handleErrors(error.errors, error);
                    setIsApproveBarcodeLoading(false);
                })
        }, [getAccessioningSample]);


        const handleApproveAction = useCallback((sampleDetails: any) => {
            const payload = {
                dateOfCollection: dateOfCollection ? CommonService.convertDateFormat(dateOfCollection, 'YYYY-MM-DD') : null,
                timeOfCollection: timeOfCollection,
                id: sampleDetails.id
            }
            handleApproveBarcodeAction(payload);

        }, [dateOfCollection, timeOfCollection, handleApproveBarcodeAction])

        const handlePatientAttachment = useCallback((attachment: any) => {
            setPatientAttachment(attachment);
            setOrderAttachment('');
        }, [])


        const handleOrderAttachment = useCallback((attachment: any) => {
            setOrderAttachment(attachment);
            setPatientAttachment('');
        }, [])

        const handleReviewBarcodeAction = useCallback((sample: any) => {
            setShowReviewDrawer(true)
        }, []);

        const handleReAssignBarcodeAction = useCallback((sample: any) => {
            setCurrentBarcodeNumber(sample.barcode);
            showReAssignBarcodeModel(true)
        }, []);

        const handleDialogClose = useCallback(() => {
            showAttachmentsModel(false);
            setPatientAttachment('');
            setOrderAttachment('');
        }, [])

        const viewAttachments = useCallback((sampleDetails: any) => {
            showAttachmentsModel(true);
            setSampleAttachmentLoading(true);
            setSampleAttachmentsLoadingFailed(false);
            setSampleAttachmentLoaded(false);
            const payload = {};
            CommonService._accessioning.viewAttachments(sampleDetails.orderDetails.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response.success) {
                        const orderAttachments = response.data.order;
                        const patientAttachments = response.data.patient;
                        setOrderAttachments(orderAttachments);
                        setPatientAttachments(patientAttachments);
                        setSampleAttachmentLoading(false);
                        setSampleAttachmentsLoadingFailed(false);
                        setSampleAttachmentLoaded(true);
                    }
                })
                .catch((error: any) => {
                    setSampleAttachmentLoading(false);
                    setSampleAttachmentsLoadingFailed(true);
                    setSampleAttachmentLoaded(false);
                    CommonService._alert.showToast(error?.message || 'Error uploading order attachment', "error");
                })

        }, []);

        const handleAttachmentsUpload = useCallback((event: any) => {
            const file = event?.target?.files[0];
            const updatedAttachmentList = [...rejectedAttachmentList, file];
            setRejectedAttachmentList(updatedAttachmentList);
            if (formikRef.current) {
                formikRef.current.setFieldValue("images", updatedAttachmentList);
            }
        }, [rejectedAttachmentList])

        const rejectSample = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
            const payload = {...values};
            payload.status = 'rejected';
            const formData = CommonService.getFormDataFromJSON(payload);
            setSubmitting(true);
            CommonService._accessioning.rejectSample(sampleDetails.id, formData)
                .then((response: IAPIResponseType<any>) => {
                    setSubmitting(false);
                    setShowReviewDrawer(false);
                    getAccessioningSample && getAccessioningSample();
                    CommonService._alert.showToast(response?.message || 'Sample has been Rejected', "success");
                })
                .catch((error: any) => {
                    CommonService.handleErrors(setErrors, error);
                    setSubmitting(false);
                });

        }, [sampleDetails, getAccessioningSample]);

        const onRejectedAttachmentClose = useCallback((index: any) => {
            const finalRejectedAttachmentList = rejectedAttachmentList.filter((attachment: any) => {
                return attachment !== rejectedAttachmentList[index];
            });
            setRejectedAttachmentList(finalRejectedAttachmentList);
            if (formikRef.current) {
                formikRef.current.setFieldValue("images", finalRejectedAttachmentList);
            }
        }, [rejectedAttachmentList])

        const closeAssignNewBarcodeModel = useCallback(() => {
            setNewBarcode('');
            showReAssignBarcodeModel(false);
        }, [setNewBarcode, showReAssignBarcodeModel]);

        const assignNewBarcode = useCallback(() => {
            const payload = {
                newBarcode: newBarcode,
            }
            setIsAssignNewBarcodeSubmitting(true);
            CommonService._accessioning.assignNewBarcode(sampleDetails.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsAssignNewBarcodeSubmitting(false);
                    closeAssignNewBarcodeModel();
                    getAccessioningSample && getAccessioningSample();
                    CommonService._alert.showToast(response?.message || 'New barcode has been Assigned', "success");
                })
                .catch((error: any) => {
                    CommonService.handleErrors(error.errors, error);
                    setIsAssignNewBarcodeSubmitting(false);
                })
        }, [sampleDetails, newBarcode, closeAssignNewBarcodeModel, getAccessioningSample]);
        const getPatientInsuranceList = useCallback(() => {
            fetchPatientInsuranceList({
                url: APIConfig.PATIENT_INSURANCE_LIST.URL(sampleDetails?.orderDetails?.patientDetails?.id),
                method: APIConfig.PATIENT_INSURANCE_LIST.METHOD,
            })
        }, [fetchPatientInsuranceList, sampleDetails?.orderDetails?.patientDetails?.id])

        const isInsuranceUpdateRequired = useCallback(() => {
            return InsuranceTypes?.some((insurance) => {
                const {
                    code: insuranceCode
                } = insurance;
                const insuranceData = sampleDetails?.[insuranceCode];
                if(!insuranceData){
                    return false;
                }
                //showing the insurance from insurance list lite because from sample details not getting insuranceObj key value.
                const updatedInsuranceData = patientInsuranceList?.find((insurance: any) => insurance?.id === insuranceData?.id);

                const isFrontImageAvailable = !!updatedInsuranceData?.frontImage?.attachmentUrl;
                const isBackImageAvailable = !!updatedInsuranceData?.backImage?.attachmentUrl;
                //checking is images available and facility required for images or not.
                if(isInsuranceImageRequired){
                    return !isFrontImageAvailable || !isBackImageAvailable
                }else{
                    return false
                }
            })
        }, [isInsuranceImageRequired, patientInsuranceList, sampleDetails])

        useEffect(() => {
            getPatientInsuranceList();
            setIsInsuranceImageRequired(sampleDetails?.orderDetails?.facilityDetails.isInsuranceImageRequired);
        }, [fetchPatientInsuranceList, getPatientInsuranceList, sampleDetails?.orderDetails?.facilityDetails.isInsuranceImageRequired]);

        return (
            <div className="accessioning-sample-card">
                <CardComponent>
                    <div className="card-content">
                        {
                            (status === 'pending' || status === 'Ready For Collection') && <Grid container spacing={2}>
                                <Grid item xs={12} md={5} className="barcode-section">
                                    <div>Barcode (Accession ID) :</div>
                                    <div
                                        className="pdd-top-5">{sampleDetails?.labBarcode ? sampleDetails?.labBarcode : sampleDetails?.barcode}</div>
                                </Grid>
                                <Grid item xs={12} md={3.5}>
                                    <div>
                                        <DatePickerComponent
                                            fullWidth={true}
                                            name={"date"}
                                            size={"small"}
                                            placeholder={"select date"}
                                            label={"Collection date"}
                                            value={dateOfCollection}
                                            onDateChange={(value: any) => setDateOfCollection(value)}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={3.5}>
                                    <div>
                                        <TimePickerComponent
                                            name={"time"}
                                            fullWidth={true}
                                            placeholder={"select time"}
                                            label={"Collection time"}
                                            size={"small"}
                                            value={timeOfCollection}
                                            onUpdate={(value: any) => {
                                                setTimeOfCollection(value)
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        }
                        {
                            status === 'accessioned' && <Grid container spacing={2}>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Barcode (Accession ID)"}> {sampleDetails?.barcode} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Date of Collection"}> {sampleDetails?.dateOfCollection} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <DetailsDataKeyValueComponent
                                        title={"Time of Collection"}> {sampleDetails?.timeOfCollection} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Date of Accession"}>
                                        {commonService.formatDate(sampleDetails?.accessionedDate)}
                                    </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Accessioned by"}> {sampleDetails?.accessionedDetails?.firstName + " " + sampleDetails?.accessionedDetails?.lastName} </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                        }

                        <div className="order-details-body">
                            <div className="order-details-header-wrapper">
                                <div className="order-details-title">Order Details:</div>
                                <div onClick={() => viewAttachments(sampleDetails)}
                                     className="view-attachments">
                                    View Attachments
                                </div>
                            </div>
                            <br/>
                            <Grid container spacing={2} className={'mrg-bottom-25'}>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Patient Name"}> {CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.orderDetails?.patientDetails.firstName) + ' ' + CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.orderDetails?.patientDetails.lastName) || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Prioritization Request"}> {sampleDetails?.isPriorityOrder ? 'Yes' : 'No' || 'N/A'} </DetailsDataKeyValueComponent>

                                    <DetailsDataKeyValueComponent
                                        title={"Consent"}> {sampleDetails?.isConsentSigned ? 'True' : 'False' || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Date of Birth"}> {sampleDetails?.orderDetails?.patientDetails?.dateOfBirth ? commonService.formatDate(sampleDetails?.orderDetails?.patientDetails?.dateOfBirth) : 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Sample Type"}> {CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.sampleType) || 'N/A'} </DetailsDataKeyValueComponent>
                                    {/*<DetailsDataKeyValueComponent*/}
                                    {/*    title={"EnB"}> {sampleDetails?.isEnbChecked===true ? 'True' :sampleDetails?.isEnbChecked===false ? 'False' : 'N/A'} </DetailsDataKeyValueComponent>*/}
                                    <DetailsDataKeyValueComponent
                                        title={"EnB"}> {'-'} </DetailsDataKeyValueComponent>

                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <DetailsDataKeyValueComponent
                                        title={"Gender"}> {CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.orderDetails?.patientDetails?.gender) || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Ordered Test"}> {CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.testDetails?.name) || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent title={"Billing Mode"}>
                                        {CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.billingMode) || 'N/A'}
                                    </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"Physician Name"}> {(sampleDetails?.physicianDetails.firstName || sampleDetails?.physicianDetails?.lastName) ? (CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.physicianDetails.firstName) + ' ' + CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.physicianDetails.lastName)) : 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Order ID"}> {"GK" + sampleDetails?.orderId || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} md={2.5}>
                                    <DetailsDataKeyValueComponent
                                        title={"NPI Number"}> {sampleDetails?.physicianDetails?.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Sample Status"}> {CommonService.capitalizeFirstLetterOfEachWord(sampleDetails?.status) || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                            {InsuranceTypes?.map((insurance) => {
                                const {
                                    title: insuranceTitle,
                                    code: insuranceCode
                                } = insurance;
                                const insuranceData = sampleDetails?.[insuranceCode];
                                if (!insuranceData) return null;
                                if (isPatientInsuranceListLoading) {
                                    return <Skeleton variant="rectangular" width="100%" height={48}
                                                     sx={{borderRadius: 1}}
                                                     className={"mrg-bottom-25"}/>;
                                }
                                //showing the insurance from insurance list lite because from sample details not getting insuranceObj key value.
                                const updatedInsuranceData = patientInsuranceList?.find((insurance: any) => insurance?.id === insuranceData?.id);

                                const isFrontImageAvailable = updatedInsuranceData?.frontImage?.attachmentUrl;
                                const isBackImageAvailable = updatedInsuranceData?.backImage?.attachmentUrl;
                                //checking is images available and facility required for images or not.
                                const updateRequired = (!isBackImageAvailable || !isFrontImageAvailable) && isInsuranceImageRequired;

                                if (!updatedInsuranceData) return null;

                                return (
                                    <div className="mrg-bottom-25 insurance-wrapper">
                                        <AccordionComponent
                                            title={insuranceTitle}
                                            subTitle={updateRequired ? "(Insurance front & back image required)" : ""}
                                            actions={
                                                updateRequired ?
                                                    <ButtonComponent
                                                        startIcon={<Edit/>}
                                                        variant={"outlined"}
                                                        fullWidth={false}
                                                        type={'button'}
                                                        size={"small"}
                                                        color={"primary"}
                                                        handleClick={() => setInsuranceDrawerConfig({
                                                            isOpen: true,
                                                            selectedInsurance: updatedInsuranceData
                                                        })}
                                                    >Edit Details</ButtonComponent>
                                                    : <></>
                                            }
                                        >
                                            <InsuranceDetailsComponent insuranceDetails={updatedInsuranceData}/>
                                        </AccordionComponent>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {(status === 'pending' || status === 'Ready For Collection') && !sampleDetails.canReAssignBarcode &&
                        <div className="card-actions">
                            <Grid container spacing={2}>
                                <Grid item xs={1} md={3}></Grid>
                                <Grid item xs={10} md={6} className="d-flex">
                                    <ButtonComponent
                                        variant={"outlined"}
                                        color={"primary"}
                                        fullWidth={true}
                                        handleClick={() => {
                                            handleReviewBarcodeAction(sampleDetails)
                                        }}
                                        size="small">
                                        Reject
                                    </ButtonComponent>
                                    <ButtonComponent
                                        className="mrg-left-10"
                                        variant={"contained"}
                                        isLoading={isApproveBarcodeLoading}
                                        disabled={isApproveBarcodeLoading || !dateOfCollection || !timeOfCollection || isInsuranceUpdateRequired()}
                                        color={"primary"}
                                        fullWidth={true}
                                        handleClick={() => handleApproveAction(sampleDetails)}
                                        size="small">Approve</ButtonComponent>
                                </Grid>
                                <Grid item xs={1} md={3}></Grid>
                            </Grid>
                        </div>
                    }
                    {status === 'pending' && sampleDetails.canReAssignBarcode &&
                        <Grid className="card-actions" container spacing={2}>
                            <Grid item xs={1} md={2}></Grid>
                            <Grid item xs={10} md={8} className="d-flex">
                                <ButtonComponent
                                    variant={"outlined"}
                                    color={"primary"}
                                    fullWidth={true}
                                    disabled={true}
                                    size="small">Review</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    variant={"contained"}
                                    disabled={true}
                                    color={"primary"}
                                    fullWidth={true}
                                    size="small">Approve</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    variant={"outlined"}
                                    color={"secondary"}
                                    fullWidth={true}
                                    handleClick={() => handleReAssignBarcodeAction(sampleDetails)}
                                    size="small">Re-assign Barcode</ButtonComponent>
                            </Grid>
                            <Grid item xs={1} md={2}></Grid>
                        </Grid>
                    }
                </CardComponent>

                <DialogComponent open={attachmentsModel}
                                 title={"Attachments"}
                                 className="attachments-dialog"
                                 onClose={handleDialogClose}
                                 isShowCancel={true}
                                 maxWidth={"md"}>
                    <div className="attachments-content-wrapper">
                        {
                            sampleAttachmentsLoading && <div className="spinner-loading-wrapper">
                                <LottieFileGenarationComponent
                                    loop={true}
                                    autoplay={true}
                                    animationData={ImageConfig.LoadingLottieFile}/>
                                <div>Sample Attachments are loading</div>
                            </div>
                        }

                        {
                            sampleAttachmentsLoadingFailed &&
                            <StatusCardComponent title={'Sample Attachments are failed to load'}/>
                        }

                        {sampleAttachmentsLoaded &&
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <div className="attachments-wrapper">
                                        <div className="attachments-title">Order Attachments</div>
                                        <div className="attachments">
                                            {orderAttachments?.length > 0 ?
                                                orderAttachments?.map((attachment: any) => {
                                                    return (
                                                        <div key={CommonService.getUUID()} onClick={() => {
                                                            handleOrderAttachment(attachment)
                                                        }}
                                                             className={"attachment-item-title-wrapper width-70"}>
                                                            <TextSnippetOutlinedIcon/>
                                                            <div
                                                                className="attachment-item-title">{attachment.title}</div>
                                                        </div>
                                                    )
                                                }) : <div className='mrg-top-10'>No Attachments</div>
                                            }

                                        </div>
                                    </div>
                                    <div className="attachments-wrapper">
                                        <div className="patient-attachments-title">Patient Attachments</div>
                                        <div className="attachments">
                                            {patientAttachments?.length > 0 ?
                                                patientAttachments?.map((attachment: any) => {
                                                    return (
                                                        <div key={CommonService.getUUID()} onClick={() => {
                                                            handlePatientAttachment(attachment)
                                                        }}
                                                             className={"attachment-item-title-wrapper width-70"}>
                                                            <TextSnippetOutlinedIcon/>
                                                            <div
                                                                className="attachment-item-title">{attachment.title}</div>
                                                        </div>
                                                    )
                                                }) : <div>No Attachments</div>
                                            }
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={8} className={'vertical-line'}>
                                    {!patientAttachment && !orderAttachment &&
                                        <div className="select-attachment-content">
                                            Select an attachment to view
                                        </div>
                                    }
                                    <div className="pdd-left-5">
                                        {
                                            patientAttachment !== '' && (patientAttachment?.mimeType === 'application/pdf' ?
                                                <PdfPreviewComponent
                                                    attachmentFile={patientAttachment}
                                                    attachmentUrl={patientAttachment?.url}
                                                    width="540"
                                                    height="500"
                                                    isFile={false}
                                                />
                                                :
                                                <FilePreviewerComponent
                                                    width="540"
                                                    height="500"
                                                    attachmentFile={patientAttachment}
                                                    attachmentUrl={patientAttachment?.url}
                                                />)
                                        }
                                    </div>
                                    <div className="pdd-left-5">
                                        {
                                            orderAttachment !== '' && (orderAttachment?.mimeType === 'application/pdf' ?
                                                <PdfPreviewComponent
                                                    attachmentFile={orderAttachment}
                                                    attachmentUrl={orderAttachment.url}
                                                    width="540"
                                                    height="500"
                                                    isFile={false}
                                                />
                                                :
                                                <FilePreviewerComponent
                                                    attachmentFile={orderAttachment}
                                                    attachmentUrl={orderAttachment.url}
                                                />)
                                        }
                                    </div>
                                </Grid>
                            </Grid>
                        }
                    </div>

                </DialogComponent>

                <DrawerComponent
                    open={insuranceDrawerConfig.isOpen}
                    closeOnBackDropClick={true}
                    closeOnEsc={true}
                    className={"drawer-wrapper"}
                    onClose={() => setInsuranceDrawerConfig({isOpen: false, selectedInsurance: undefined})}
                >
                    <InsuranceFormComponent
                        formInitialValues={insuranceDrawerConfig.selectedInsurance}
                        patientID={sampleDetails?.orderDetails?.patientDetails?.id}
                        isInsuranceImageRequired={isInsuranceImageRequired}
                        formTitle={""}
                        insuranceMode={'edit'}
                        onUpdateComplete={(data: any) => {
                            getPatientInsuranceList()
                            setInsuranceDrawerConfig({isOpen: false, selectedInsurance: undefined})
                        }}
                    />
                </DrawerComponent>
                <DrawerComponent open={showReviewDrawer}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 onClose={() => {
                                     setRejectedAttachmentList([]);
                                     setInitialValues(formInitialValues);
                                     setShowReviewDrawer(false);
                                 }}>
                    <div className={'accessioning-drawer-component screen t-form-screen'}>

                        <div className="drawer-sub-header horizontal-vertical-center-align">
                            <HeadingComponent title={"Reject Sample"}/>
                        </div>
                        <div className="t-form t-form-drawer">
                            <Formik
                                validationSchema={reviewFormValidationSchema}
                                initialValues={initialValues}
                                validateOnChange={false}
                                validateOnBlur={true}
                                enableReinitialize={true}
                                validateOnMount={true}
                                innerRef={formikRef}
                                onSubmit={rejectSample}
                            >
                                {({isSubmitting, values, isValid, validateForm, errors, touched}) => {
                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                    useEffect(() => {
                                        validateForm();
                                    }, [validateForm, values, errors, touched]);
                                    return (
                                        <Form className={"review-form-holder"}>
                                            <div className="t-form-controls-wrapper">
                                                <Field name={'reason'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikSelectDropdownComponent
                                                                label={'Select Reason'}
                                                                required={true}
                                                                formikField={field}
                                                                options={reasonList}
                                                                valueKey={"code"}
                                                            />
                                                        )
                                                    }
                                                </Field>

                                                <Field name={'comment'}>
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Enter your comments (if any)'}
                                                                placeholder={''}
                                                                type={"text"}
                                                                multiline={true}
                                                                rows={3}
                                                                formikField={field}
                                                            />
                                                        )
                                                    }
                                                </Field>

                                                <div className="attachment-upload-wrapper">

                                                    <div className="d-flex">
                                                        <div className="attachment-upload-label">
                                                            Add photo(s)
                                                        </div>
                                                        <div
                                                            className="mrg-left-15">
                                                            <TooltipComponent
                                                                placement={'right'}
                                                                tooltip={"Only JPEG and PNG with max. size of 5MB are allowed."}
                                                                arrow={true}>
                                                                <HelpIcon/>
                                                            </TooltipComponent>
                                                        </div>
                                                    </div>

                                                    <div className="attachment-upload-list">
                                                        <div className="attachment-upload-item">
                                                            <>
                                                                <input id={"file"} type={"file"}
                                                                       className={"display-none"}

                                                                       ref={rejectFileRef}
                                                                       accept={"image/jpg, image/jpeg, image/png"}
                                                                       onClick={(event: any) => {
                                                                           event.target.value = null
                                                                       }}
                                                                       onChange={(event) => {
                                                                           handleAttachmentsUpload(event);
                                                                       }}
                                                                />
                                                                <div className="attachment-upload-item-upload-file-wrapper">
                                                                    <div className="attachment-upload-item-upload-file"
                                                                         onClick={() => {
                                                                             rejectFileRef.current?.click();
                                                                         }}
                                                                    >
                                                                        <div
                                                                            className="attachment-upload-item-upload-icon">
                                                                            <AddAPhotoIcon/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    (_.get(touched, "images") && !!(_.get(errors, "images"))) &&
                                                                    <ErrorComponent
                                                                        errorText={(_.get(errors, "images"))}/>
                                                                }
                                                            </>
                                                        </div>

                                                        {
                                                            values?.images?.length > 0 &&
                                                            <>
                                                                {
                                                                    values?.images?.map((image: any, index: number) => {
                                                                        return (
                                                                            <ThumbnailComponent
                                                                                key={index}
                                                                                width={70}
                                                                                height={100}
                                                                                onClose={() => {
                                                                                    onRejectedAttachmentClose(index);
                                                                                }}
                                                                                attachmentFile={image}
                                                                                isFile={true}/>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="drawer-actions form-action-section">
                                                <ButtonComponent
                                                    type="submit"
                                                    color={"primary"}
                                                    variant={"contained"}
                                                    fullWidth={true}
                                                    disabled={!isValid}
                                                    isLoading={isSubmitting}
                                                    buttonProps={{
                                                        id: "save_btn"
                                                    }}
                                                >
                                                    Reject
                                                </ButtonComponent>
                                            </div>
                                        </Form>
                                    )
                                }}
                            </Formik>
                        </div>

                    </div>
                </DrawerComponent>
                <DialogComponent open={reAssignBarcodeModel}
                                 onClose={closeAssignNewBarcodeModel}
                                 title="Re-Assigning Barcode"
                                 description="The new barcode assigned will not replace the previous barcode. It will merely replace the
                                               existing barcode while it is being processed in the laboratory."
                                 maxWidth={"sm"}>
                    <div className="barcode-reassign-wrapper">
                        <div className="existed-barcode-wrapper">
                            <div className="current-barcode-title">Current Barcode</div>
                            <div className="current-barcode-value">{currentBarcodeNumber}</div>
                        </div>
                        <div>
                            <InputComponent type={"text"}
                                            name={"newBarcode"}
                                            placeholder={"Enter new barcode"}
                                            value={newBarcode}
                                            label={'New Barcode'}
                                            id="barcode_input"
                                            onChange={(value: string) => {
                                                setNewBarcode(value);
                                            }}
                            />
                        </div>
                        <div className="drawer-actions form-action-section d-flex justify-content-center">
                            <ButtonComponent
                                type={"submit"}
                                color={'primary'}
                                variant={"contained"}
                                disabled={newBarcode.length === 0}
                                isLoading={isAssignNewBarcodeSubmitting}
                                handleClick={assignNewBarcode}
                            >
                                Assign Barcode
                            </ButtonComponent>
                        </div>
                    </div>
                </DialogComponent>

            </div>
        )
    }

;

export default AccessioningSampleCard;
